import { Component, ViewChild, Input, ViewEncapsulation, OnInit, EventEmitter, Output } from '@angular/core';
import { ValueAccessorBase } from '../value-accessor-base';
import { NgModel, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ILabel } from '../ILabel.model';

@Component({
    selector: 'cpq-toggle',
    templateUrl: 'cpq-toggle.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CpqToggleComponent,
            multi: true
        }
    ],
    styleUrls: ['./cpq-toggle.component.scss'],
    standalone: false
})
export class CpqToggleComponent extends ValueAccessorBase<boolean> implements OnInit {
  @ViewChild(NgModel, { static: true }) model: NgModel;

  @Input('name') name: string;
  @Input('label') label: ILabel;
  @Input('disabled') disabled: boolean;
  @Input('infoMessage') infoMessage?: ILabel;
  @Input('short') short: boolean;
  @Input('condensed') condensed: boolean;
  @Input('tabindex') tabindex?: number;
  @Output('onInfoClick') onInfoClick = new EventEmitter<any>();

  constructor(
    public route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
  }

  infoClicked() {
    this.onInfoClick.emit();
  }

}
